import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faUser,
    faCartShopping,
    faBox,
    faHeart,
    faRightFromBracket,
    faChevronDown,
    faLocationDot
} from "@fortawesome/free-solid-svg-icons";

function MainHeader({ isLoggedIn, setIsLoggedIn, cartCount }) {

    const [user, setUser] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            fetchName();
        } else {
            setUser("")
        }
    }, [isLoggedIn])

    const fetchName = async () => {
        try {
            const res = await API.get("/api/auth/getDetails");
            setUser(res.data.name.split(" ")[0]);

        } catch (error) {
            console.log(error);
        }
    };


    const [search, setSearch] = useState("")
    const [suggestions, setSuggestions] = useState([])

    const handleSearch = async (e) => {

        const value = e.target.value;
        setSearch(value)

        if (value.length > 0) {
            try {
                const res = await API.get(`/api/products/search?keyword=${value}`);
                setSuggestions(res.data)
            } catch (error) {
                console.log(error)
            }
        } else {
            setSuggestions([]);
        }
    }

    return (
        <section className="main-header">

            <div className="search-box">
                <div className="search-form">
                    <button type="submit" className="search-btn">
                        <FontAwesomeIcon icon={faSearch} />
                    </button>

                    <input
                        type="text"
                        value={search}
                        onChange={handleSearch}
                        placeholder="Search for Products, Brands and More"
                        className="search-input"
                    />
                    {
                        suggestions.length > 0 && (
                            <div className="search-dropdown">
                                {
                                    suggestions.slice(0, 5).map((item) => (
                                        <div
                                            key={item.id}
                                            className="search-item"
                                            onClick={() => {
                                                navigate(`/search?q=${item.name}`);
                                                setSuggestions([])
                                            }
                                            }
                                        >
                                            <button type="submit" className="search-btn">
                                                <FontAwesomeIcon icon={faSearch} />
                                            </button>
                                            <div className="search-text">
                                                <p className="product-name">{item.name}</p>
                                                <p className="product-category">in Products</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
            </div>

            <div className="header-right">

                {isLoggedIn ? (
                    <>

                        <div className="profile">
                            <span className="profile-trigger">
                                <span style={{ fontSize: "18px" }}><FontAwesomeIcon icon={faUser} /></span> {user || "User"}
                                <span className="profile-arrow">
                                    <FontAwesomeIcon icon={faChevronDown} />
                                </span>
                            </span>

                            <div className="dropdown">
                                <p className="dropdown-title">Your Account</p>

                                <div className="dropdown-item" onClick={() => navigate("/profile")}>
                                    <FontAwesomeIcon icon={faUser} />My Profile
                                </div>

                                <div className="dropdown-item" onClick={() => navigate("/orders")}>
                                    <>
                                        <FontAwesomeIcon icon={faBox} /> Orders
                                    </>
                                </div>

                                <div className="dropdown-item" onClick={() => navigate("/choose-location")}>
                                    <>
                                        <FontAwesomeIcon icon={faLocationDot} />
                                        {" "}Saved Addresses
                                    </>
                                </div>

                                <div className="dropdown-item" onClick={() => navigate("/wishlist")}>
                                    <>
                                        <FontAwesomeIcon icon={faHeart} /> Wishlist
                                    </>
                                </div>

                                <div className="dropdown-item logout"
                                    onClick={() => {
                                        localStorage.removeItem("userToken");
                                        setIsLoggedIn(false);
                                        navigate("/login");
                                    }}>
                                    <>
                                        <FontAwesomeIcon icon={faRightFromBracket} /> Logout
                                    </>
                                </div>
                            </div>
                        </div>

                        <div className="more">
                            <span>More
                                <span className="profile-arrow">
                                    <FontAwesomeIcon icon={faChevronDown} />
                                </span>
                            </span>
                            <div className="dropdown">
                                <Link to="/seller">Become Seller</Link>
                                <Link to="/notifications">Notifications</Link>
                                <Link to="/help">Customer Care</Link>
                            </div>
                        </div>

                    </>
                ) : (
                    <div className="auth-links">
                        <span
                            className="auth-item"
                            onClick={() => navigate("/login")}
                        >
                            Login
                        </span>

                        <span className="auth-separator">|</span>

                        <span
                            className="auth-item"
                            onClick={() => navigate("/register")}
                        >
                            Register
                        </span>
                    </div>
                )}

                <Link to="/cart" className="cart">
                    <>
                        <FontAwesomeIcon icon={faCartShopping} /> Cart
                    </> <span className="cart-count">{cartCount}</span>
                </Link>

            </div>
        </section>
    );
}

export default MainHeader;